//React
//Components
import {
  AlphaNumericInput,
  Button,
  Card,
  Chart,
  DashboardAddMember,
  DashboardHeader,
  DashboardScreen,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  OrganisationSelectionModal,
  Radio,
  RupeeAmount,
  Screen,
  TitleBlock,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  AddUserApi,
  CreateApplicationApi,
  GetTeamDetailsApi,
  GetUserDetailsApi,
  registerClientApi,
  RemoveUserApi,
  setGeneralDetails,
  UpdateOrganisationApi,
  useGeneralDetails,
  useGetTeamDetailsApiDetails,
  useGetUserDetailsApiDetails,
  useRegisterClientApiDetails,
} from "Slices";
//Utils
import { ChangeHistory, EventManager, EventNames, validateEmail } from "utils";
//Styles
import "./styles.scss";
//Assets
import JavaIcon from "assets/icons/java.png";
import AndroidIcon from "assets/icons/android.svg";
import AppleIcon from "assets/icons/apple.svg";
import RestApiIcon from "assets/icons/rest-api.svg";
import DeleteIcon from "assets/Dashboard/icons/delete.png";
import ChangeIcon from "assets/icons/change.png";
//Library
import cx from "classnames";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const Organization = () => {
  //Dispatch
  const dispatch = useDispatch();
  const [organisationName, setOrganisationName] = useState("");
  const [hasRightAccess, setHasRightAccess] = useState(false);
  const [
    dashboardAddMemberModalVisibility,
    setDashboardAddMemberModalVisibility,
  ] = useState(false);
  const [
    organisationSelectionModalVisibility,
    setOrganisationSelectionModalVisibility,
  ] = useState(false);

  //Slices
  const userDetails = useGetUserDetailsApiDetails();
  const teamDetails = useGetTeamDetailsApiDetails();
  const generalDetails = useGeneralDetails();

  const createApplication = () => {
    //
  };

  const addTeamMemeber = (memberDetails) => {
    dispatch(
      AddUserApi({
        organizationId: localStorage.getItem("organisationID"),
        ...memberDetails,
        callback: (response) =>
          checkIfOrganisationUpdated({
            ...response,
            toastMessage: "User added successfully",
          }),
      })
    );
  };

  const removeTeamMemeber = (memberDetails) => {
    dispatch(
      RemoveUserApi({
        organizationId: localStorage.getItem("organisationID"),
        ...memberDetails,
        callback: (response) =>
          checkIfOrganisationUpdated({
            ...response,
            toastMessage: "User removed successfully",
          }),
      })
    );
  };

  const updateOrganisation = () => {
    dispatch(
      UpdateOrganisationApi({
        organizationId: localStorage.getItem("organisationID"),
        companyName: organisationName,
        callback: (response) =>
          checkIfOrganisationUpdated({
            ...response,
            toastMessage: "Organisation details updated successfully",
          }),
      })
    );
  };

  const getTeamDetails = () => {
    dispatch(
      GetTeamDetailsApi({
        organizationId: localStorage.getItem("organisationID"),
      })
    );
  };

  const checkIfOrganisationUpdated = (response) => {
    setDashboardAddMemberModalVisibility(false);
    getTeamDetails();
    response.success && toast.success(response?.toastMessage);
  };

  useEffect(() => {
    getTeamDetails();

    setOrganisationName(generalDetails?.selectedOrganisation?.companyName);
  }, []);

  //Render UI
  const TopSection = <DashboardHeader title={"Organization Settings"} />;

  const OrganizationDetails = (
    <FlexBox flexColumn alignEnd className="pos-rel">
      {userDetails?.data?.organizations?.length > 1 && (
        <Button
          text={"Change Organisation"}
          className="mr-t-20"
          variant="outline"
          onClick={() => {
            setOrganisationSelectionModalVisibility(true);
          }}
        />
      )}
      <div className="w-100">
        <FlexBox justifyBetween alignCenter className="mr-v-40 w-50">
          <div className="w-70">
            <AlphaNumericInput
              hasLabel
              value={organisationName}
              onChange={setOrganisationName}
              className="fs-14"
              placeholder={"Organization Name"}
            />
          </div>
          <Button
            text={"Save"}
            className="w-20"
            disabled={
              organisationName ===
              generalDetails?.selectedOrganisation?.companyName
            }
            onClick={() => {
              updateOrganisation();
            }}
          />
        </FlexBox>
      </div>
    </FlexBox>
  );

  const TeamDetails = (
    <div className="team-details border-bottom">
      <FlexBox className="fs-12 border-bottom pd-b-10">
        <p className="w-60">Email</p>
        <p className="w-30">Role</p>
      </FlexBox>
      {teamDetails?.data.length > 0 &&
        teamDetails?.data?.map((item: any, index: number) => {
          if (item.email === userDetails?.data?.email && !hasRightAccess)
            setHasRightAccess(true);
          return (
            <FlexBox
              className="fs-14 font-medium dashed-border-bottom pd-v-20 data"
              key={`organisation-team-details-${index}`}
            >
              <p className="w-60">{item.email}</p>
              <p className="w-30">{item.accessType}</p>
              {item.email !== userDetails?.data?.email && hasRightAccess && (
                <div className="w-10 text-right pd-r-10">
                  <Image
                    src={DeleteIcon}
                    className="delete-icon curs-point clicking-animation"
                    onClick={() => {
                      removeTeamMemeber({
                        email: item.email,
                      });
                    }}
                  />
                </div>
              )}
            </FlexBox>
          );
        })}
    </div>
  );

  const AddTeamMember = (
    <Button
      variant="white"
      text={"+ Add Team Member"}
      className="mr-t-10 no-shadow bg-transparent fs-14 pd-h-0"
      onClick={() => {
        setDashboardAddMemberModalVisibility(true);
      }}
    />
  );

  //Return UI
  return (
    <DashboardScreen
      className="organisation-screen"
      hasSideMenu
      hasHeader
      screenAnimationClass="no-animation"
    >
      {TopSection}
      {OrganizationDetails}
      {TeamDetails}
      {AddTeamMember}
      <DashboardAddMember
        visible={dashboardAddMemberModalVisibility}
        onClose={() => {
          setDashboardAddMemberModalVisibility(false);
        }}
        action={addTeamMemeber}
      />
      <OrganisationSelectionModal
        visible={organisationSelectionModalVisibility}
        onClose={() => {
          setOrganisationSelectionModalVisibility(false);
        }}
        showCross={true}
      />
    </DashboardScreen>
  );
};

export default Organization;
